import React from 'react'
import Nav from './Nav'

const Contact = () => {
    return (
        <>
            <main id="main" class="bg-img">
                <div id="bgImg">
                    <div class="container">

                        <Nav />

                        <div class="content">
                            <div class="contact_us">
                                <span>Contact</span>
                                <h1>Contact</h1>
                                <img src="img/phone-call.png" style={{ display: " inline-block", marginLeft: "-57px" }} />
                                <p className='mb-0'>+201067799939</p><br />
                                <img src="img/pin.png" style={{ display: " inline-block", marginLeft: "-57px" }} />
                                <p className='mb-0'>Suez, Egypt</p><br />
                                <img src="img/email.png" style={{ display: " inline-block", marginLeft: "-57px" }} />
                                <p>perfectsoftwarecompany@gmail.com</p>
                            </div>
                            <div class="div-map">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d110594.49028460917!2d32.58153582067315!3d29.977193424844792!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1456257838ae4111%3A0x1f0a056a97ea1bc0!2z2KfZhNiz2YjZitiz!5e0!3m2!1sar!2seg!4v1632943916135!5m2!1sar!2seg"
                                    width="350" height="300" className='border-0' allowfullscreen="" loading="lazy"
                                    class="map"></iframe>
                            </div>
                        </div>

                        <div class="social-media" style={{marginTop: "393px"}}>
                            <a href="https://www.facebook.com/Perfect-151150445074122"><img src="img/facebook.png" /></a>
                            <a
                                href="https://www.instagram.com/perfect94446783/?fbclid=IwAR14fVz3P2rQ5x8Y8sAlERhd1ldCJhGDPt8M1KAoDsH3sO-y_vDRKNy4Yqg"><img
                                    src="img/instagram.png" /></a>
                            <a href="https://www.youtube.com/channel/UC-RBwShQdGVl8aQCo2tyHnA/featured"><img
                                src="img/youtube.png" /></a>

                            <span>SOCIAL MEDIA</span>
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}

export default Contact
